"use client"

import {signIn, signOut} from "next-auth/react";

export async function handleSignIn(formData: FormData) {
    const callbackUrl = formData.get("callbackUrl") as string;

    if (!callbackUrl) {
        throw new Error("callbackUrl is missing");
    }

    await signIn("microsoft-entra-id", { redirectTo: callbackUrl });
}

export async function SignOut() {
    return await signOut();
}